/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import dataTableData from "layouts/management/popup/popup-list/data/dataTableData";
import { Modal, Radio, RadioGroup, Switch, Typography } from "@mui/material";
import MDInput from "components/MDInput";
import { PopupService } from "service/popup/service";

function PopupList(): JSX.Element {
  const [description, setdescription] = useState();
  const [img, setimg] = useState();
  const [startDt, setstartDt] = useState();
  const [endDt, setendDt] = useState();
  const [isDisplay, setisDisplay] = useState("N");
  const [popuplist, setpopuplist] = useState(dataTableData());
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [pIdx, setPIdx] = useState("");
  const [isupdateimg, setisupdateimg] = useState(false);
  const [imglink, setimglink] = useState("");
  const upload = async () => {
    try {
      await PopupService.create(description, img, startDt, endDt, isDisplay);
      setOpen(false);
      list();
    } catch (err) {
      console.log(err);
    }
  };
  const update = async () => {
    try {
      await PopupService.update(description, startDt, endDt, isDisplay, pIdx);
      setOpen2(false);
      list();
    } catch (err) {
      console.log(err);
    }
  };
  const updatewithimg = async () => {
    try {
      await PopupService.updatewithimg(description, img, startDt, endDt, isDisplay, pIdx);
      setOpen2(false);
      list();
    } catch (err) {
      console.log(err);
    }
  };
  const deletePopup = async () => {
    try {
      await PopupService.delete(pIdx);
      setOpen2(false);
      list();
    } catch (err) {
      console.log(err);
    }
  };

  const list = async () => {
    try {
      const res = await PopupService.list();
      setpopuplist(
        dataTableData(
          res.data.map((el: any) => {
            return {
              ...el,
              period: [el.startDt, el.endDt],
              isDisplay: el.isDisplay === "Y" ? "표시" : "비표시",
              pIdx2: el.pIdx,
            };
          }),
          view
        )
      );
      console.log("데이터가 들어왔습니다:");
    } catch (err) {
      console.log(err);
    }
  };

  const view = async (pIdx: string) => {
    try {
      const res = await PopupService.view(pIdx);
      setOpen2(true);
      setPIdx(pIdx);
      setisupdateimg(false);
      setdescription(res.data[0].description);
      setendDt(res.data[0].endDt && res.data[0].endDt.slice(0, 10));
      setstartDt(res.data[0].startDt && res.data[0].startDt.slice(0, 10));
      setisDisplay(res.data[0].isDisplay);
      setSelectedImage(null);
      setimg(null);
      setimglink(res.data[0].img);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    list();
  }, []);

  const reset = () => {
    setdescription(null);
    setimg(null);
    setstartDt(null);
    setendDt(null);
    setisDisplay("N");
    setSelectedImage(null);
  };

  return (
    <DashboardLayout>
      {modal1(
        open,
        setOpen,
        setimg,
        setSelectedImage,
        selectedImage,
        description,
        setdescription,
        startDt,
        setstartDt,
        endDt,
        setendDt,
        isDisplay,
        setisDisplay,
        img,
        upload
      )}
      {modal2(
        open2,
        setOpen2,
        setisupdateimg,
        setimg,
        setSelectedImage,
        selectedImage,
        isupdateimg,
        imglink,
        description,
        setdescription,
        startDt,
        setstartDt,
        endDt,
        setendDt,
        isDisplay,
        setisDisplay,
        updatewithimg,
        update,
        deletePopup
      )}
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <MDButton
            color="success"
            onClick={() => {
              setOpen(true);
              reset();
            }}
          >
            새로운 팝업
          </MDButton>
          <MDBox display="flex">
            <MDBox ml={1}>
              <MDButton variant="outlined" color="dark">
                <Icon>description</Icon>
                &nbsp;export csv
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
        <Card>
          <DataTable
            table={popuplist}
            entriesPerPage={false}
            canSearch={false}
            isSorted={false}
            showTotalEntries={false}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default PopupList;
function modal2(
  open2: boolean,
  setOpen2: any,
  setisupdateimg: any,
  setimg: any,
  setSelectedImage: any,
  selectedImage: any,
  isupdateimg: boolean,
  imglink: string,
  description: undefined,
  setdescription: any,
  startDt: undefined,
  setstartDt: any,
  endDt: undefined,
  setendDt: any,
  isDisplay: string,
  setisDisplay: any,
  updatewithimg: () => Promise<void>,
  update: () => Promise<void>,
  deletePopup: () => Promise<void>
) {
  return (
    <Modal
      open={open2}
      onClose={() => setOpen2(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        padding: "32px",
        overflowY: "auto",
      }}
    >
      <MDBox
        bgColor="white"
        p="24px"
        borderRadius="16px"
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>이미지</Typography>
          <MDInput
            onChange={(e: any) => {
              setisupdateimg(true);
              setimg(e.target.files[0]);
              if (e.target.files[0]) {
                const reader = new FileReader();

                reader.onload = (e) => {
                  setSelectedImage(e.target.result);
                };

                reader.readAsDataURL(e.target.files[0]);
              }
            }}
            type="file"
          />
        </MDBox>
        {selectedImage ? (
          <MDBox display="flex" flexDirection="column" width="100%" alignItems="start">
            <Typography>미리보기</Typography>
            <img
              src={selectedImage}
              style={{ width: "312px", alignSelf: "center", border: "1px solid black" }}
              alt=""
            />
          </MDBox>
        ) : (
          ""
        )}
        {isupdateimg ? (
          ""
        ) : (
          <MDBox display="flex" flexDirection="column" width="100%" alignItems="start">
            <Typography>이전 이미지</Typography>
            <img
              src={`${process.env.REACT_APP_HOST}img/${imglink}`}
              style={{ width: "312px", alignSelf: "center", border: "1px solid black" }}
              alt=""
            />
          </MDBox>
        )}
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>설명</Typography>
          <MDInput
            value={description}
            width="100%"
            onChange={(e: any) => setdescription(e.target.value)}
          />
        </MDBox>
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>기간</Typography>
          <MDInput value={startDt} onChange={(e: any) => setstartDt(e.target.value)} type="date" />
          <MDInput value={endDt} onChange={(e: any) => setendDt(e.target.value)} type="date" />
        </MDBox>
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>표시</Typography>
          <Switch
            checked={isDisplay === "Y"}
            onClick={() => setisDisplay(isDisplay === "Y" ? "N" : "Y")}
          />
        </MDBox>
        <MDButton
          color={description && startDt && endDt && isDisplay ? "success" : "light"}
          onClick={
            description && startDt && endDt && isDisplay
              ? isupdateimg
                ? updatewithimg
                : update
              : () => alert("내용을 입력해주세요")
          }
        >
          update
        </MDButton>
        <MDButton color={"error"} onClick={deletePopup}>
          delete
        </MDButton>
      </MDBox>
    </Modal>
  );
}

function modal1(
  open: boolean,
  setOpen: any,
  setimg: any,
  setSelectedImage: any,
  selectedImage: any,
  description: undefined,
  setdescription: any,
  startDt: undefined,
  setstartDt: any,
  endDt: undefined,
  setendDt: any,
  isDisplay: string,
  setisDisplay: any,
  img: undefined,
  upload: () => Promise<void>
) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        padding: "32px",
        overflowY: "auto",
      }}
    >
      <MDBox
        bgColor="white"
        p="24px"
        borderRadius="16px"
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>이미지</Typography>
          <MDInput
            onChange={(e: any) => {
              setimg(e.target.files[0]);
              if (e.target.files[0]) {
                const reader = new FileReader();

                reader.onload = (e) => {
                  setSelectedImage(e.target.result);
                };

                reader.readAsDataURL(e.target.files[0]);
              }
            }}
            type="file"
          />
        </MDBox>
        {selectedImage ? (
          <MDBox display="flex" flexDirection="column" width="100%" alignItems="start">
            <Typography>미리보기</Typography>
            <img
              src={selectedImage}
              style={{ width: "312px", alignSelf: "center", border: "1px solid black" }}
              alt=""
            />
          </MDBox>
        ) : (
          ""
        )}
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>설명</Typography>
          <MDInput
            value={description}
            width="100%"
            onChange={(e: any) => setdescription(e.target.value)}
          />
        </MDBox>
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>기간</Typography>
          <MDInput value={startDt} onChange={(e: any) => setstartDt(e.target.value)} type="date" />
          <MDInput value={endDt} onChange={(e: any) => setendDt(e.target.value)} type="date" />
        </MDBox>
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography>표시</Typography>
          <Switch
            checked={isDisplay === "Y"}
            onClick={() => setisDisplay(isDisplay === "Y" ? "N" : "Y")}
          />
        </MDBox>
        <MDButton
          color={description && img && startDt && endDt && isDisplay ? "success" : "light"}
          onClick={
            description && img && startDt && endDt && isDisplay
              ? upload
              : () => alert("내용을 입력해주세요")
          }
        >
          upload
        </MDButton>
      </MDBox>
    </Modal>
  );
}
